import React, { Component } from 'react';
import { connect } from "react-redux";
import { Trans } from 'react-i18next';

import axios from "axios";

class EmptyState extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    render() {
        return (
            <div style = {{width:'100%'}}>
                <div className = "emptystate-container text-center" style={{width: "100px"}}>
                    <img src = {this.props.image.includes("images/emptystate-icons/") ? this.props.image : "images/emptystate-icons/" + this.props.image} />
                    <div className = "displaysmall"><Trans>{this.props.text}</Trans></div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = store => ({
    userSession: store.userSession
})

export default connect(mapStateToProps)(EmptyState)